import { BrandConfigService } from '../../services/brand-config.service';

export function getBuilderModels(brandConfig: BrandConfigService) {
  return {
    ANNOUNCEMENTS: brandConfig.currentConfig.builderModels.announcements,
    FOOTER: brandConfig.currentConfig.builderModels.footer
  } as const;
} 